class NavigationService {
  constructor() {
    this.lastPosition = null;
    this.stationaryTimer = null;
    this.reminderInterval = null;
  }

  checkIfStationary(currentPosition, destination, navigationId) {
    if (!this.lastPosition) {
      this.lastPosition = currentPosition;
      return;
    }

    const distance = this.calculateDistance(
      this.lastPosition.lat,
      this.lastPosition.lng,
      currentPosition.lat,
      currentPosition.lng
    );

    // MODIFIÉ : 2 minutes au lieu de 5
    if (distance < 50) {
      if (!this.stationaryTimer) {
        this.stationaryTimer = setTimeout(() => {
          this.notifyArrival(destination, navigationId);
        }, 2 * 60 * 1000); // 2 minutes
      }
    } else {
      if (this.stationaryTimer) {
        clearTimeout(this.stationaryTimer);
        this.stationaryTimer = null;
      }
    }

    this.lastPosition = currentPosition;
  }

  calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371e3;
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  }

  notifyArrival(destination, navigationId) {
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification('🏁 Arrivée détectée', {
        body: `Vous êtes immobile depuis 2 minutes. Destination: ${destination || 'Non spécifiée'}`,
        icon: '/logo.png',
      });
    }

    alert(`🏁 Arrivée détectée ! Vous êtes immobile depuis 2 minutes.`);
  }

  startNavigationReminders() {
    this.reminderInterval = setInterval(() => {
      if ('Notification' in window && Notification.permission === 'granted') {
        new Notification('⚓ Navigation en cours', {
          body: 'Pensez à vérifier votre position régulièrement',
          icon: '/logo.png',
        });
      }
    }, 30 * 60 * 1000);
  }

  stopNavigationReminders() {
    if (this.reminderInterval) {
      clearInterval(this.reminderInterval);
      this.reminderInterval = null;
    }
  }

  reset() {
    if (this.stationaryTimer) {
      clearTimeout(this.stationaryTimer);
      this.stationaryTimer = null;
    }
    this.stopNavigationReminders();
    this.lastPosition = null;
  }
}

export const navigationService = new NavigationService();